<div
  class="table-container mt-0 max-h-[calc(90vh-170px)] overflow-y-auto border border-[#ddd]"
>
  <table class="table-fixed w-full table-striped">
    <thead class="h-[50px] w-full sticky top-0 bg-[#1A4971] !z-20">
      <tr
        class="bg-muted text-muted-foreground text-[#343A40] bg-[#DEE2E6] !font-Roboto !text-left"
      >
        <th class="row">Addendum Title</th>
        <th class="row">Date Created</th>
        <th class="p-2 !text-left">Status</th>
        <th class="text-center row">Action</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="addendums && addendums?.length > 0">
        <tr
          *ngFor="let addendum of addendums; let i = index"
          class="hover:bg-muted/50 font-bold !font-Roboto !cursor-default border-b"
        >
          <td class="!text-left cursor-pointer row">
            {{ addendum?.title }}
          </td>
          <td class="!text-left row">
            {{ addendum?.created_at | date : "d/M/y" }}
          </td>
          <td class="border-b row !text-left !pl-[10px]">
            <app-status-badge
              [status]="addendum?.addendum_status"
            ></app-status-badge>
          </td>
          <td class="text-center row">
            <button mat-button [matMenuTriggerFor]="menu">
              <img
                src="assets/icons/action_icon.svg"
                alt="action icon"
                class=""
              />
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openDialog(addendum)">
                <mat-icon style="color: #2196f3">visibility</mat-icon>
                <span>View</span>
              </button>
            </mat-menu>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
<app-view-detail-addendum
  [isDialogOpen]="isDialogOpen"
  [addendum]="selectedAddendum"
></app-view-detail-addendum>
